import { LANGUAGE_OPTIONS } from "@/consts/const"
import ja_ServicePage from "@/langs/ja/pages/ServicePage.json"
import en_ServicePage from "@/langs/en/pages/ServicePage.json"
import ja_ServiceStatusPage from "@/langs/ja/pages/ServiceStatusPage.json"
import en_ServiceStatusPage from "@/langs/en/pages/ServiceStatusPage.json"
import ja_const from "@/langs/ja/const.json";
import en_const from "@/langs/en/const.json";
import ja_ServiceSummaryItem from "@/langs/ja/service/ServiceSummaryItem.json"
import en_ServiceSummaryItem from "@/langs/en/service/ServiceSummaryItem.json"
import ja_EventList from "@/langs/ja/event/EventList.json"
import en_EventList from "@/langs/en/event/EventList.json"
import ja_EventTabs from "@/langs/ja/event/EventTabs.json"
import en_EventTabs from "@/langs/en/event/EventTabs.json"
import ja_ImportantMessageArea from "@/langs/ja/important-message/ImportantMessageArea.json"
import en_ImportantMessageArea from "@/langs/en/important-message/ImportantMessageArea.json"
import ja_ImportantOldList from "@/langs/ja/important-message/ImportantOldList.json"
import en_ImportantOldList from "@/langs/en/important-message/ImportantOldList.json"
import ja_GlobalFooter from "@/langs/ja/layout/GlobalFooter.json"
import en_GlobalFooter from "@/langs/en/layout/GlobalFooter.json"
import ja_SiteImageArea from "@/langs/ja/layout/SiteImageArea.json"
import en_SiteImageArea from "@/langs/en/layout/SiteImageArea.json"
import ja_SiteSimpleImageArea from "@/langs/ja/layout/SiteSimpleImageArea.json"
import en_SiteSimpleImageArea from "@/langs/en/layout/SiteSimpleImageArea.json"
import ja_AccessErrorPage from "@/langs/ja/pages/AccessErrorPage.json"
import en_AccessErrorPage from "@/langs/en/pages/AccessErrorPage.json"
import ja_EventDetailPage from "@/langs/ja/pages/EventDetailPage.json"
import en_EventDetailPage from "@/langs/en/pages/EventDetailPage.json"
import ja_EventPage from "@/langs/ja/pages/EventPage.json"
import en_EventPage from "@/langs/en/pages/EventPage.json"
import ja_ImportantOldPage from "@/langs/ja/pages/ImportantOldPage.json"
import en_ImportantOldPage from "@/langs/en/pages/ImportantOldPage.json"
import ja_ServiceStatusUpdateArea from "@/langs/ja/service-status/ServiceStatusUpdateArea.json"
import en_ServiceStatusUpdateArea from "@/langs/en/service-status/ServiceStatusUpdateArea.json"
const messages = {
    ja: {
        message: {
            ServicePage: ja_ServicePage,
            ServiceStatusPage: ja_ServiceStatusPage,
            Const: ja_const,
            ServiceSummaryItem: ja_ServiceSummaryItem,
            EventList: ja_EventList,
            EventTabs: ja_EventTabs,
            ImportantMessageArea: ja_ImportantMessageArea,
            ImportantOldList: ja_ImportantOldList,
            GlobalFooter: ja_GlobalFooter,
            SiteImageArea: ja_SiteImageArea,
            SiteSimpleImageArea: ja_SiteSimpleImageArea,
            AccessErrorPage: ja_AccessErrorPage,
            EventDetailPage: ja_EventDetailPage,
            EventPage: ja_EventPage,
            ImportantOldPage: ja_ImportantOldPage,
            ServiceStatusUpdateArea: ja_ServiceStatusUpdateArea,
        }
    },
    en: {
        message: {
            ServicePage: en_ServicePage,
            ServiceStatusPage: en_ServiceStatusPage,
            Const: en_const,
            ServiceSummaryItem: en_ServiceSummaryItem,
            EventList: en_EventList,
            EventTabs: en_EventTabs,
            ImportantMessageArea: en_ImportantMessageArea,
            ImportantOldList: en_ImportantOldList,
            GlobalFooter: en_GlobalFooter,
            SiteImageArea: en_SiteImageArea,
            SiteSimpleImageArea: en_SiteSimpleImageArea,
            AccessErrorPage: en_AccessErrorPage,
            EventDetailPage: en_EventDetailPage,
            EventPage: en_EventPage,
            ImportantOldPage: en_ImportantOldPage,
            ServiceStatusUpdateArea: en_ServiceStatusUpdateArea,
        }
    },
}

const i18nConfig = {
    locale: LANGUAGE_OPTIONS.JA.VALUE,
    legacy: false,
    fallbackLocale: [LANGUAGE_OPTIONS.EN.VALUE],
    messages: messages,
}

export default i18nConfig
